module.exports = __webpack_public_path__ + "static/media/avatar-profile.eee8ed92.png";